import React from 'react';
import {Form, Select, Input, Button, Radio} from 'antd';

import {FormInput} from './InputMask';

const {Item} = Form;
const {Option} = Select;
const {Group} = Radio;
const {TextArea} = Input;


export class UserForm extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                const mapArr = {}
                this.props.handleSubmit(values, (errors) => {
                    errors.map((item) => {
                        mapArr[item.attribute] = {
                            errors: [new Error(item.value[0])],
                        }
                    })
                    this.props.form.setFields(mapArr);
                });
            }
        });
    };

    render() {
        const {form} = this.props;
        const {getFieldDecorator} = form;
        return (
            <Form onSubmit={this.handleSubmit}>
                <Item label="Фамилия">
                    {getFieldDecorator('last_name', {
                        rules: [{
                            required: true, message: 'Введите фамилию',
                        }],
                    })(
                        <Input placeholder="Фамилия"/>
                    )}
                </Item>
                <Item label="Имя">
                    {getFieldDecorator('first_name', {
                        rules: [{
                            required: true, message: 'Введите имя',
                        }],
                    })(
                        <Input placeholder="Имя"/>
                    )}
                </Item>
                <Item label="Отчество">
                    {getFieldDecorator('middle_name', {
                        rules: [{
                            required: true, message: 'Введите отчество',
                        }],
                    })(
                        <Input placeholder="Отчество"/>
                    )}
                </Item>
                {/*<Item label="День рождения">*/}
                {/*{getFieldDecorator('birthdate')(*/}
                {/*<Input placeholder="дд.мм.гггг" />*/}
                {/*)}*/}
                {/*</Item>*/}
                <FormInput
                    form={this.props.form} // antd form
                    mask={'11.11.1111'}
                    placeholder="дд.мм.гггг"
                    label={'Дата рождения'}
                    name={'birthdate'}
                    rules={[{required: true, message: 'Введите дату рождения'}]}
                />
                <Item label="Пол" style={{display: "none"}}>
                    {getFieldDecorator('gender', {
                        rules: [{
                            required: true, message: 'Выберите пол',
                        }],
                        initialValue: this.props.selectedGender === "male" ? "0" : "1"
                    })(
                        <Group>
                            <Radio value="0">Мужской</Radio>
                            <Radio value="1">Женский</Radio>
                        </Group>
                    )}
                </Item>
                <Item label="Электронная почта">
                    {getFieldDecorator('email', {
                        rules: [{
                            type: 'email', message: 'Некорректная почта',
                        }],
                    })(
                        <Input/>
                    )}
                </Item>
                {/*<Item label="Контактный телефон">*/}
                {/*{getFieldDecorator('phone', {*/}
                {/*rules: [{*/}
                {/*required: true, message: 'Введите контактный телефон',*/}
                {/*}],*/}
                {/*})(*/}
                {/*<Input placeholder="+7 (XXX) XXX XX XX" />*/}
                {/*)}*/}
                {/*</Item>*/}
                <FormInput
                    form={this.props.form} // antd form
                    mask={'+7 (111) 111 11 11'}
                    placeholder="+7 (XXX) XXX XX XX"
                    label={'Контактный телефон'}
                    name={'phone'}
                    emptyValue={'+7 ('}
                    rules={[{required: true, message: 'Введите контактный телефон'}]}
                />
                <Item label="Место работы">
                    {getFieldDecorator('workplace', {
                        rules: [{
                            required: true, message: 'Введите место работы',
                        }],
                    })(
                        <Input placeholder="Место работы"/>
                    )}
                </Item>
                <Item label="Комментарий">
                    {getFieldDecorator('comment', {
                        rules: [{
                            required: false
                        }],
                    })(
                        <TextArea rows={4} placeholder="Комментарий к записи"/>
                    )}
                </Item>
                <div style={{display: 'flex', justifyContent: 'space-between'}}>
                    <Button
                        onClick={this.props.prev}
                        style={{width: '49%'}}
                        size="large"
                    >Назад</Button>
                    <Button
                        htmlType="submit"
                        size="large"
                        style={{width: '49%'}}
                    >Отправить</Button>
                </div>
            </Form>
        )
    }
}

export default Form.create()(UserForm);



// WEBPACK FOOTER //
// frontend/src/modules/mobile/components/UserForm.jsx